<script>
import { PasswordInputAlt } from "../main";

let password = "hello1234";
</script>

<PasswordInputAlt bind:value={password} />
